import React, { Component } from 'react';
import { translate } from 'react-i18next';

//import { Table } from 'react-bootstrap';

//var Config = require('../../../config');

class ApheresisData extends Component{
	constructor(props, context) {
		super(props, context);

		this.keyPressed = this.keyPressed.bind(this);
	}

	//Consulta de servicios necesarios para la pantalla
	componentDidMount() {
		this.props.onRef(this);
	}

	componentWillUnmount() {
		this.props.onRef(null)
	}

	keyPressed(e){
		if(e.key === '.' || e.key === 'e' || e.key === '-'){
			e.preventDefault();
		}else if(e.key === 'Enter'){
			this.props.validate(e);
		}else{
			if(e.target.name.indexOf('equiv') === -1){
				if(e.target.value.length >= 4){
					e.preventDefault();
				}
			}else{
				if(e.target.value.length >= 20){
					e.preventDefault();
				}
			}
			
		}
	}


	//Contenido del Formulario
	render(){
		const { t } = this.props;
		var col = '';
		var with_kit1 = 'col-xs-12';
		var with_kit2 = 'col-xs-12 col-sm-3';
		
		return(
			<div>
				{!this.props.state.hideFieldsAph ? 
					<div>
						<div className="col-xs-12" style={{padding:"0px"}}>
							<div className="col-xs-12  col-sm-2">
								<span className="span-min">{t('content.extractions.apheresis.lote_anticuagulant')}</span>
								<input className="form-control" name="lote_anticuagulant" id="lote_anticuagulant" 
									value={ this.props.state.lote_anticuagulant } onChange={ this.props.handleChange }
									onKeyPress={(e) => this.props.validate(e)}
									disabled={this.props.state.offer.type_extraction_name==="SANGRE TOTAL"?
										!this.props.state.can_be_edit || this.props.state.disabled_element
									:false}/>
							</div>

							<div className="col-xs-12 col-sm-2">
								<span className="span-min">{t('content.extractions.apheresis.volume_anticoagulant')}</span>
								<input className="form-control" name="volume_anticoagulant" id="volume_anticoagulant" 
									value={ this.props.state.volume_anticoagulant } onChange={ this.props.handleChange }
									onKeyPress={(e) => this.props.validate(e)} type="number"
									disabled={this.props.state.offer.type_extraction_name==="SANGRE TOTAL"?
										!this.props.state.can_be_edit || this.props.state.disabled_element
									:false}/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">{t('content.extractions.apheresis.cycle_number')}</span>
								<input className="form-control" name="cycle_number" id="cycle_number" 
									value={ this.props.state.cycle_number } onChange={ this.props.handleChange }
									onKeyPress={(e) => this.props.validate(e)}
									disabled={this.props.state.offer.type_extraction_name==="SANGRE TOTAL"?
										!this.props.state.can_be_edit || this.props.state.disabled_element
									:false}/>
							</div>
							<div className="col-xs-12 col-sm-2">
								<span className="span-min">{t('content.extractions.apheresis.processed_blood')}</span>
								<input className="form-control" name="processed_blood" id="processed_blood" 
									value={ this.props.state.processed_blood || "" } onChange={ this.props.handleChange }
									onKeyPress={(e) => this.props.validate(e)}
									disabled={this.props.state.offer.type_extraction_name==="SANGRE TOTAL"?
										!this.props.state.can_be_edit || this.props.state.disabled_element
									:false}/>
							</div>
						</div>

						<div className="col-xs-12" style={{padding:"0px"}}>
							<div className="col-xs-12  col-sm-4">
					        	<span className="span-min">{t('content.extractions.apheresis.apheresis_kits_id')}</span>
								<select className="form-control" required value={ this.props.state.apheresis_kits_id || ""} 
						        	onChange={ this.props.handleChange.bind(this) } name="apheresis_kits_id" 
						        	id="apheresis_kits_id" disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
						        	onKeyPress={(e) => this.props.validate(e)}>
					              	<option value="" disabled>Seleccionar...</option>
					                {
					                	this.props.state.apheresis.map(function(t){
					                		return <option key={t.apheresis_kit.id} value={t.apheresis_kit.id} >{t.apheresis_kit.name}</option>;
					                	})
					                }
					            </select>
					        </div>

					        <div className="col-xs-12 col-sm-2" style={{marginTop:"20px"}}>
					        	<input type="checkbox" name="double" id="double" value={this.props.state.double } 
					    				onChange={this.props.doubleCheck.bind(this)} disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
					    				checked={this.props.state.double} onKeyPress={(e) => this.props.validate(e)}
					    				ref={(input) => { this.double_check = input; }} 
					    				style={{margin:"0 5px 0 5px"}}/>
					    		<span className="span-min">
					    			Doble
					    		</span>
					    	</div>

							{this.props.state.offer.type_extraction_name==='CÉLULAS' &&
								<div className='col-xs-12 col-sm-2'>
									<span className='span-min'>No. de Células</span>
									<input className='form-control hout-input' name='number_cells' id='number_cells' 
										value={this.props.state.number_cells} onChange={()=>this.props.handleChange.bind(this)}
										disabled
									/>
								</div>
							}
					    </div>

					    <div className="col-xs-12" style={{padding:"0px"}}>
					    	<div className="col-sm-6">
					    		<div className="col-xs-12 col-sm-6">
					    		
						    	</div>
						    	<div className="col-xs-12 col-sm-3" style={{textAlign:"center"}}>
						    		<span className="span-min">Bolsa 1</span>
						    	</div>
						    	{this.props.state.double ?
						    		<div className="col-xs-12 col-sm-3" style={{textAlign:"center"}} >
							    		<span className="span-min">Bolsa 2</span>						    		
							    	</div>
							    :null
						    	}
							    	
					    	</div>
					    </div>

					    <div className="col-xs-12" style={{padding:"0px"}}>

					    	<div className="col-sm-6 form-group">
					        	{this.props.state.component_kit.length > 0 ?
					        		this.props.state.component_kit.map((c, i)=>( 
						        		<div className="col-xs-12 " key={c.id}>	
							        		<div className="col-xs-6" style={{padding:"5px 0 0 0"}}>
							        			<span className="span-min">{c.component}</span>
							        		</div>
												
							        			{this.props.state.unit[i] !== undefined ?
							        				this.props.state.unit[i].map((u, j)=>(
														j === 0 ?
															<div key={j} className="col-xs-3" style={{padding:"5px 0 0 12px"}}> 
																<div>
																	<input id={'vol_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit} type="number"
																		className="form-control volume-unit" 
																		value={u.volume || ""} //onKeyPress={(e) => this.validateInput(e)}
																		name={'vol_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																		onKeyPress={this.keyPressed} disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
																		onChange={this.props.onVolumeChange}
																		placeholder={t('content.extractions.components_kit.volumen')}
																		required />
																</div>

																{u.flag  &&
																	<div>
																		<span className="span-min">Rendimiento P.</span>
																		<input className="form-control volume-unit"
																			id={'rend_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			value={u.rendimiento}
																			name={'rend_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			//disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
																			onChange={(e)=>this.props.onValueChange(e, 'rendimiento', i, j)}
																			
																		/>
																	</div>
																}
																{u.flag &&
																	<div>
																		<span className="span-min">U. Equivalente</span>
																		<input className="form-control volume-unit" 
																			id={'equiv_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			value={u.equivalente }
																			name={'equiv_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			onKeyPress={this.keyPressed} 
																			//disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
																			onChange={(e)=>this.props.onValueChange(e, 'equivalente', i, j)}
																			
																		/>
																	</div>
																}
															
															</div>
														: this.props.state.double && j > 0?
															<div key={j} className="col-xs-3" style={{padding:"5px 0 0 12px"}}> 
																<div>
																	<input id={'vol_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit} type="number" 
																		className="form-control volume-unit" 
																		name={'vol_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																		value={u.volume || ""} //onKeyPress={(e) => this.props.validate(e)}
																		onKeyPress={this.keyPressed} disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
																		onChange={this.props.onVolumeChange}
																		placeholder={t('content.extractions.components_kit.volumen')}
																	/>
																</div>
																{u.flag &&
																	<div>
																		<span className="span-min">Rendimiento P.</span>
																		<input className="form-control volume-unit"
																			id={'rend_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			value={u.rendimiento}
																			name={'rend_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			//disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
																			onChange={(e)=>this.props.onValueChange(e, 'rendimiento', i, j)}
																			
																		/>
																	</div>
																}
																{u.flag &&
																	<div>
																		<span className="span-min">U. Equivalente</span>
																		<input className="form-control volume-unit" 
																			id={'equiv_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			value={u.equivalente}
																			onKeyPress={this.keyPressed}
																			name={'equiv_'+this.props.state.asigned_kit[i].blood_component_id+'_'+u.unit}
																			//disabled={!this.props.state.can_be_edit || this.props.state.disabled_element}
																			onChange={(e)=>this.props.onValueChange(e, 'equivalente', i, j)}
																			
																		/>
																	</div>
																}
															</div>
														: null

							        				))
							        			:null}								        		
							        	</div>
					        		))
					        		: null
					    		}
					        </div>
					    </div>

					</div>
					:null
				}
	        </div>
		);
	}
}

export default translate('translations')(ApheresisData);